export function getView(value) {
  return value ? 'Active' : 'Inactive'
}
